import { Component, OnInit } from '@angular/core';
import { MatList, MatListItem, MatListItemTitle } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { DocumentsOfferingService } from "../../services/documents-offering.service";
import { DocumentsOffering } from "../../models/documents-offering.model";
import { DocumentsPartialOffering } from "../../models/documents-partial-offering.model";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionModule } from "@angular/material/expansion";
import { ToastrService } from "ngx-toastr";
import { MatProgressSpinner } from "@angular/material/progress-spinner";


@Component({
  selector: 'app-meus-documentos',
  standalone: true,
  imports: [
    MatList,
    MatListItem,
    MatIcon,
    MatListItemTitle,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionModule,
    MatProgressSpinner
  ],
  templateUrl: './my-documents.component.html',
  styleUrl: './my-documents.component.css'
})

export class MyDocumentsComponent implements OnInit{
  documentsOfferings: DocumentsOffering[] = [];
  documentsPartialOfferings: DocumentsPartialOffering[] = [];
  loading = false;
  groupedOfferings: { courseOfferingName: string, documents: any[] }[] = [];

  constructor(private documentsOfferingService: DocumentsOfferingService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.documentsOfferingService.getDocuments().subscribe(
      (documentsData) => {
        if (documentsData) {
          this.documentsOfferings = documentsData.filter(course => course.documents && course.documents.length > 0);
        }else {
          this.documentsOfferings = [];
        }
        this.groupDocumentsByCourseOffering();
      },
      (error) => {
        console.error('Erro ao carregar os documentos', error);
      }
    );
    this.documentsOfferingService.getDocumentsPartial().subscribe(
      (partialData) => {
        this.documentsPartialOfferings = partialData;
        this.groupDocumentsByCourseOffering();
      },
      (error) => {
        console.error('Erro ao carregar os documentos', error);
      }
    );

  }

  // Junta os documentos e atestados por courseOfferingName
  groupDocumentsByCourseOffering(): void {
    const grouped: { [key: string]: { courseOfferingName: string, documents: any[] } } = {};

    // Junta documentos
    this.documentsOfferings.forEach((docOffering) => {
      const courseName = docOffering.courseOfferingName;
      if (!grouped[courseName]) {
        grouped[courseName] = { courseOfferingName: courseName, documents: [] };
      }
      // Adiciona os documentos ao grupo de documentos
      grouped[courseName].documents.push(...docOffering.documents);
    });

    // Junta os atestados
    if (Array.isArray(this.documentsPartialOfferings)) {
      this.documentsPartialOfferings.forEach((partialOffering) => {
        const courseName = partialOffering.courseOfferingName;
        if (!grouped[courseName]) {
          grouped[courseName] = { courseOfferingName: courseName, documents: [] };
        }
        // Adiciona o atestado ao grupo de documentos
        grouped[courseName].documents.push(partialOffering);
      });
    }

    // Converte o grupo de documentos para um array
    this.groupedOfferings = Object.values(grouped);
    this.loading = false;
  }

  openDocumentPDF(documentId: number, event: MouseEvent): void {
    if (documentId === undefined) {
      this.toastr.error('ID do documento nÃ£o encontrado. Por favor, tente novamente.', 'Erro');
      return;
    }
    event.preventDefault();
    this.loading = true;

    this.documentsOfferingService.getDocumentsPDF(documentId).subscribe(
      (response: Blob) => {
        const fileURL = URL.createObjectURL(response);
        window.open(fileURL, '_blank');
        URL.revokeObjectURL(fileURL);
        this.toastr.success('Documento aberto com sucesso!', 'Sucesso');
        this.loading = false;
      },
      (errorMessage) => {
        this.toastr.error(errorMessage);
        this.loading = false;
      }
    );
  }

  openDocumentPartialPDF(documentPartialId: number, event: MouseEvent): void {
    if (documentPartialId === undefined) {
      this.toastr.error('ID do documento nÃ£o encontrado. Por favor, tente novamente.', 'Erro');
      return;
    }
    event.preventDefault();
    this.loading = true;

    this.documentsOfferingService.getDocumentsPartialPDF(documentPartialId).subscribe(
      (response: Blob) => {
        const fileURL = URL.createObjectURL(response);
        window.open(fileURL, '_blank');
        URL.revokeObjectURL(fileURL);
        this.toastr.success('Documento aberto com sucesso!', 'Sucesso');
        this.loading = false;
      },
      (errorMessage) => {
        this.toastr.error(errorMessage);
        this.loading = false;
      }
    );
  }

  protected readonly document = document;
}
